import { titleCase } from "../../../helper";
import {
  BoxTab,
  BoxTabEach,
  TabHeader,
  TabSub,
} from "../../../pages/YachtClubViewDetails";

interface VesselDetailsProps {
  vesselName: string;
  registrationNumber: string;
  brandBuilder: string;
  yearBuilt: string;
  loaM: string;
  beamM: string;
  draftM: string;
}

const VesselDetails = ({
  vesselName,
  registrationNumber,
  brandBuilder,
  yearBuilt,
  loaM,
  beamM,
  draftM,
}: VesselDetailsProps) => {
  return (
    <>
      <BoxTab>
        <BoxTabEach>
          <TabHeader>Vessel Name</TabHeader>
          <TabSub>{titleCase(vesselName)}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Registration Number</TabHeader>
          <TabSub>{registrationNumber}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Brand/Builder</TabHeader>
          <TabSub>{titleCase(brandBuilder)}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Year Built</TabHeader>
          <TabSub>{yearBuilt}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>LOA (m)</TabHeader>
          <TabSub>{loaM}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Beam (m)</TabHeader>
          <TabSub>{beamM}</TabSub>
        </BoxTabEach>
        <BoxTabEach>
          <TabHeader>Draft (m)</TabHeader>
          <TabSub>{draftM}</TabSub>
        </BoxTabEach>
      </BoxTab>
    </>
  );
};

export default VesselDetails;
